<template>
	<div>
		<!-- <changeLang /> -->
		<div id="signin">
			<div class="container-login">
				<md-card style="min-width: 400px" class="md-elevation-5">
					<md-card-header style="display: flex" data-background-color="purple">
						<h3 style="margin: auto">{{ $t("signup-header") }} {{ $route.params.name }}</h3>
					</md-card-header>
					<md-card-content style="display: flex; margin-top: 50px">
						<div style="margin-left: auto; margin-right: auto; min-width: 300px">
							<!-- CODICE MECCANOGRAFICO -->
							<md-field :class="validSchoolCode || !school_code ? '' : 'md-invalid'">
								<md-icon v-bind:style="{ color: !validSchoolCode ? 'red' : 'grey' }">school</md-icon>
								<md-input
									name="school_code"
									:minlength="10"
									:maxlength="10"
									v-model="school_code"
									:placeholder="$t('school-code')"
									@input="checkSchoolCode"
								/>
								<span class="md-error">{{ $t("code-field-required") }}</span>
								<span>
									<md-icon style="color: red" v-if="!schoolcodeUnique">error</md-icon>
									<md-tooltip md-direction="top">{{ $t("code-already-exists") }}</md-tooltip>
								</span>
							</md-field>

							<!-- NOME E COGNOME -->
							<md-field v-if="!schoolcodeUnique">
								<md-icon v-bind:style="{ color: 'grey' }"> account_circle </md-icon>
								<md-input name="namesurname" v-model="namesurname" :placeholder="$t('namesurname')" />
							</md-field>

							<!-- USERNAME -->
							<md-field :class="validUsername || !username ? '' : 'md-invalid'" v-if="schoolcodeUnique">
								<md-icon v-bind:style="{ color: error && !username ? 'red' : 'grey' }">
									account_circle
								</md-icon>
								<md-input
									name="username"
									v-model="username"
									:placeholder="$t('username')"
									@input="checkUsername"
								/>
								<span class="md-error">{{ $t("username-error") }}</span>
								<span>
									<md-icon style="color: red" v-if="!usernameUnique">error</md-icon>
									<md-tooltip md-direction="top">{{ $t("username-unique-error") }}</md-tooltip>
								</span>
							</md-field>
							<!-- PERSONAL MAIL -->
							<md-field :class="validEmail || !email ? '' : 'md-invalid'">
								<md-icon v-bind:style="{ color: error && !email ? 'red' : 'grey' }">email</md-icon>
								<md-input name="email" v-model="email" :placeholder="$t('email')" @input="checkEmail" />
								<span class="md-error">{{ $t("invalid-email") }}</span>
								<span>
									<md-icon style="color: red" v-if="!emailUnique">error</md-icon>
									<md-tooltip md-direction="top">{{ $t("email-unique-error") }}</md-tooltip>
								</span>
							</md-field>

							<md-field :class="{ 'md-invalid': !(validPassword || !password) }" v-if="schoolcodeUnique">
								<md-icon
									v-bind:style="{
										color: error && (password != re_password || !password) ? 'red' : 'grey'
									}"
								>
									vpn_key
								</md-icon>
								<md-input
									name="password"
									v-model="password"
									:placeholder="$t('password')"
									type="password"
								/>
								<span class="md-error">{{ $t("password-error") }}</span>
							</md-field>

							<md-field
								:class="{ 'md-invalid': !(validRePassword || !re_password) }"
								v-if="schoolcodeUnique"
							>
								<md-icon
									v-bind:style="{
										color: error && (password != re_password || !password) ? 'red' : 'grey'
									}"
								>
									vpn_key
								</md-icon>
								<md-input
									name="password"
									v-model="re_password"
									:placeholder="$t('retype-password')"
									type="password"
								/>
								<span class="md-error">{{ $t("re-password-error") }}</span>
							</md-field>

							<md-checkbox v-model="accept1" :class="{ 'md-invalid': true }" v-if="schoolcodeUnique">
								<span
									@click="
										e => {
											e.stopPropagation()
										}
									"
									v-html="
										$t('accept-1').replace(
											'%LINK%',
											'https://www.redigopa.it/info-privacy-registrazione-piattaforma/'
										)
									"
								/>
								<span style="margin-left: 16px" v-if="!accept1">
									<md-icon style="color: red">error</md-icon>
									<md-tooltip md-direction="top">{{ $t("must-accept") }}</md-tooltip>
								</span>
							</md-checkbox>

							<br />

							<md-checkbox v-model="accept2" :class="{ 'md-invalid': !accept2 }" v-if="schoolcodeUnique">
								<span
									@click="
										e => {
											e.stopPropagation()
										}
									"
									v-html="$t('accept-2').replace('%LINK%', 'https://www.redigopa.it/contratto/')"
								/>
								<span style="margin-left: 16px" v-if="!accept2">
									<md-icon style="color: red">error</md-icon>
									<md-tooltip md-direction="top">{{ $t("must-accept") }}</md-tooltip>
								</span>
							</md-checkbox>
						</div>
					</md-card-content>
					<div style="display: flex; margin: 25px" v-if="!schoolcodeUnique">
						<el-alert
							:title="$t('code-already-exists')"
							:description="$t('send-email-details')"
							type="success"
							:closable="false"
						>
						</el-alert>
					</div>

					<div style="display: flex; margin-top: 25px">
						<md-button
							style="margin: auto"
							class="md-round md-primary"
							@click="signup"
							:disabled="disabledButton"
							v-if="schoolcodeUnique"
						>
							<i class="el-icon-loading" v-show="sending" />
							{{ $t("signup") }}
						</md-button>
						<md-button
							style="margin: auto"
							class="md-round md-primary"
							@click="sendEmail"
							:disabled="!namesurname || !email || !validEmail"
							v-if="!schoolcodeUnique"
						>
							<i class="el-icon-loading" v-show="sending" />
							{{ $t("send-email") }}
						</md-button>
					</div>
					<div style="text-align: center; margin-top: 20px">
						<router-link to="/login">{{ $t("login-instead") }}</router-link>
					</div>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios"
import ChangeLang from "./layout/layout-components/ChangeLang"

export default {
	name: "Signup",
	components: {
		changeLang: ChangeLang
	},
	data() {
		return {
			password: undefined,
			re_password: undefined,
			username: undefined,
			namesurname: undefined,
			email: undefined,
			accept1: false,
			accept2: false,
			logged: undefined,
			error: false,
			hasMessages: true,
			organization_name: undefined,
			usernameUnique: true,
			schoolcodeUnique: true,
			emailUnique: true,
			school_code: undefined,
			fiscal_code: undefined,
			error: [],
			schoolCodeIsValid: false,
			sending: false
		}
	},
	watch: {
		school_code: function () {
			this.school_code = this.school_code.toUpperCase()
			if (this.school_code.length > 10) {
				if (this.error.indexOf("school_code") == -1) this.error.push("school_code")
			}

			if (this.school_code.length == 10) this.schoolCodeIsValid = true
		}
	},
	computed: {
		validUsername: function () {
			if (!this.username) return false
			var res = this.username.match(/^[a-zA-Z0-9._]{3,100}$/g)
			return res ? true : false
		},
		validEmail: function () {
			if (!this.email) return false
			var res = this.email.match(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/g)
			return res ? true : false
		},
		validPassword: function () {
			if (!this.password) return false
			var res = this.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/g)
			return res ? true : false
		},
		validRePassword: function () {
			if (!this.re_password) return false
			if (this.password != this.re_password) return false
			return true
		},
		validOrganizationName: function () {
			if (this.organization_name) return true
			return false
		},
		validSchoolCode: function () {
			if (this.school_code) {
				var r = this.school_code.length
				return r == 10
			}
			return false
		},
		disabledButton: function () {
			return (
				!this.validUsername ||
				!this.validEmail ||
				!this.emailUnique ||
				!this.validSchoolCode ||
				!this.validPassword ||
				!this.validRePassword ||
				!this.accept1 ||
				!this.accept2 ||
				this.sending
			)
		}
	},
	methods: {
		checkUsername: function () {
			if (!this.validUsername) {
				this.usernameUnique = true
				return
			}

			axios
				.post(process.env.VUE_APP_API_URL + "/api/user/checkIfExist", { value: this.username })
				.then(res => {
					this.usernameUnique = false
				})
				.catch(err => {
					if (err.response.data.Message[0] == "no-rows") {
						this.usernameUnique = true
					} else {
						console.error(err)
						this.$processError(this.$t("registration-error"), err.response.data.Message)
					}
				})
		},
		checkSchoolCode: function () {
			if (!this.validSchoolCode) {
				this.schoolcodeUnique = true
				return
			}

			axios
				.post(process.env.VUE_APP_API_URL + "/api/organizations/checkIfExist", { value: this.school_code })
				.then(res => {
					if (res.data.school_code) this.schoolcodeUnique = true
				})
				.catch(err => {
					if (err.response.data.Message[0] == "no-rows") {
						this.schoolcodeUnique = true
					} else if (err.response.data.Message[0] == "code-already-exists") {
						this.schoolcodeUnique = false
					} else {
						console.error(err)
						this.$processError(this.$t("registration-error"), err.response.data.Message)
					}
				})
		},
		checkEmail: function () {
			if (!this.validEmail) {
				this.emailUnique = true
				return
			}

			axios
				.post(process.env.VUE_APP_API_URL + "/api/user/checkIfExist", {
					value: this.email
				})
				.then(res => {
					this.emailUnique = false
				})
				.catch(err => {
					if (err.response.data.Message[0] == "no-rows") {
						this.emailUnique = true
					} else {
						console.error(err)
						this.$processError(this.$t("registration-error"), err.response.data.Message)
					}
				})
		},
		signup: function () {
			if (!this.school_code || !this.password || !this.username || !this.email) {
				this.error = true
				return
			}
			if (this.password != this.re_password || !this.password) {
				this.error = true
				return
			}
			var payload = {
				username: this.username,
				password: this.password,
				email: this.email,
				school_code: this.school_code,
				language: localStorage.getItem("lang")
			}

			this.sending = true

			axios
				.post(process.env.VUE_APP_API_URL + "/api/user/createUserNewOrganization", payload)
				.then(() => {
					this.$notification(
						"success",
						this.$t("registration-successful"),
						this.$t("confirmation-mail-sent"),
						4500
					)
				})
				.catch(err => {
					console.error(err)
					this.$processError(this.$t("registration-error"), err.response.data.Message)
					this.error = true
				})
				.finally(() => (this.sending = false))
		},
		sendEmail: function () {
			var payload = {
				email: this.email,
				school_code: this.school_code,
				namesurname: this.namesurname
			}

			this.sending = true

			axios
				.post(process.env.VUE_APP_API_URL + "/api/user/askForSignup", payload)
				.then(() => {
					this.$notification("success", this.$t("email-okay"), "", 4500)
				})
				.catch(err => {
					console.error(err)
					this.$processError(this.$t("email-error"), err.response.data.Message)
					this.error = true
				})
				.finally(() => (this.sending = false))
		},
		clickAccept(e) {
			e.stopPropagation()
		}
	}
}
</script>

<style scoped>
#signin {
	margin: 0;
	position: absolute !important;
	top: 50%;
	left: 50%;
	-ms-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
}
.container-login {
	margin-left: auto;
	margin-right: auto;
}
.md-card {
	padding-bottom: 25px;
}
.radio {
	color: rgba(0, 0, 0, 0.54);
	font-size: 16px;
}
.center {
	margin: auto;
}
</style>
